
import { QuizzPropsProps } from '../types';
import api from './api';

export async function handleQuizz(params: QuizzPropsProps.Request) {
    const res = await api.post<QuizzPropsProps.Response>(`/Leads`, {...params});
    return res.data;
}
